<template lang="pug">
modal#confirm-exclude-document-signer-modal.text-center(
  :buttonColor='buttonColor'
  :close-button-label='$t("modal.envelope.fields.excludeDocumentsModal.cancelButton")'
  :loading='loading'
  :process-button-label='$t("modal.envelope.fields.excludeDocumentsModal.confirmButton")'
  :title='$t("modal.envelope.fields.excludeDocumentsModal.title")'
  @process='$emit("process"); $refs.modal.close()'
  processButtonClass='btn-danger'
  ref='modal'
  size='md'
)
  .text-start.mb-3(
    v-html='$t("modal.envelope.fields.excludeDocumentsModal.message1")'
  )
  .text-start {{ $t('modal.envelope.fields.excludeDocumentsModal.message2') }}
  img.mt-4.mb-3(
    alt='draft-delete-warning'
    src='/img/ilustrations/application-warning.svg'
  )
</template>

<script>
import Modal from '@/ui/molecules/Modal.vue';
import ImageLoader from '@/ui/molecules/ImageLoader.vue';

export default {
  name: 'ConfirmExcludeDocumentSignerModal',
  components: {
    Modal,
    ImageLoader,
  },
  data() {
    return {
      loading: false,
      buttonColor: true,
    };
  },
};
</script>
